import React from 'react';
import ExampleField from 'components/card/components/CardContents/ExampleField';
import styles from './styles.module.css';

/**
 * @typedef DragCardFieldPreviewProps
 * @prop {import('../dnd/DraggableCardField').default | import('../dnd/DraggableFieldPreview').default} dragItem The drag item for the field being dragged.
 * @prop {boolean} dragLayer Whether the preview is in the drag layer.
 */

/**
 * @type {React.FC<DragCardFieldPreviewProps>}
 */
const DragCardFieldPreview = ({ dragItem, dragLayer = false }) => {
  const { field } = dragItem;

  let content = <ExampleField field={field} />;

  if (dragLayer) {
    content = <div className={styles.cardFieldDragPreview}>{content}</div>;
  } else {
    content = <div className={styles.cardFieldBeingDragged}>{content}</div>;
  }

  return content;
};

export default DragCardFieldPreview;
